import { getService } from "~/lib/services/services-manager";
import {User} from "~/lib/models/user";

export const getToken = async ({ email, password, sessionUuid }) => {
  const service = getService("auth-service");
  const response = await service.post("/auth/authenticate", { email: email.trim(), password: password.trim(), sessionUuid });
  const { token, refreshToken } = response.data;
  return { 
    sessionUuid: response.data.sessionUuid,
    token,
    refreshToken,
  };
};

export const getSessionData = async token => {
  const service = getService("server-app");
  const response = await service.get("/acl/admin-client-session-data", { headers: { Authorization: `Bearer ${token}` } });
  return { ...response.data?.session, user: User.fromPayload(response.data?.session.user)};
};

export const authorize = async token => {
  const service = getService("auth-service");
  await service.get("/auth/authorize", { headers: { Authorization: `Bearer ${token}` } });
};

export const sendActivationEmail = async (email) => {
  const service = getService('server-app');
  await service.post('/users/signup/activation', { email });
};

export const accountActivation = async ({code, password}) => {
  const service = getService("server-app");
  await service.post("/users/signup/account-activation", {code, password});
  return true;
};

export const sendResetPasswordEmail = async (email, type) => {
  const service = getService("server-app");
  await service.post("/users/send-reset-password-email", {email, type});
};

export const resetPassword = async ({code, password}) => {
  const service = getService("server-app");
  await service.post("/users/reset-password", {code, password});
  return true;
};
